<template>
  <div>
    <v-row align="center" justify="center">
      <v-col class="text-center px-5 py-2" cols="12" md="9">
        <v-col cols="12">
          <v-btn
            icon
            title="Acceso a la Información"
            aria-label="Acceso a la Información"
          >
            <v-icon size="60">fas fa-scroll</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="12" class="mt-1">
          <span
            class="font-weight-bold leading--text mb-3"
            :style="
              $vuetify.breakpoint.xs ? 'font-size: 25px' : 'font-size: 32px'
            "
            >Acceso a la Información</span
          >
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col justify="center">
        <v-card>
          <v-tabs v-model="tab">
            <v-tab href="#tab-informacion">
              Información
            </v-tab>
            <v-tab href="#tab-parametros">
              Parámetros
            </v-tab>
          </v-tabs>
          <v-tabs-items :value="tab">
            <v-tab-item value="tab-informacion">
              <v-card-text>
                Información
              </v-card-text>
            </v-tab-item>
            <v-tab-item value="tab-parametros">
              <v-card-text>
                <div >

                <table     
                >
                <tr >
                  <td  >
                  <p   >&nbsp;</p>
                  </td>
                  <td   >
                  <p   ><b><span >ENTIDAD QUE SOLICITA </span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Nombre de La Enditad</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Fecha de Solicitud</p>
                  </td>
                  <td   >
                  <p   ><span >aaaa-mm-dd</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b>CONTACTOS</b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Nombre(s) y Apellido(s)</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Cargo</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Dependencia</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Email</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Teléfono</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                  <td  >
                  <p   >Extensión</p>
                  </td>
                  <td  >
                  <p   ><span >Número de Ext.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Celular</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Nombre(s) y Apellido(s)</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Cargo</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Dependencia</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Email</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Teléfono</p>
                  </td>
                  <td  >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                  <td   >
                  <p   >Extensión</p>
                  </td>
                  <td  >
                  <p   ><span >Número de Ext.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   >Celular</p>
                  </td>
                  <td   >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b>&nbsp;</b></p>
                  <p   ><b>Nota: </b>Para la aprobación de esta solicitud, se requiere
                  su evaluación por parte del CENDOJ, que colocará en los apartados de
                  observaciones: “Aprobado”, o las observaciones pertinentes a que hubiere
                  lugar.</p>
                  <p   >&nbsp;</p>
                  <p   >En caso de haber observaciones, estas se remitirán para su
                  revisión por parte de la entidad solicitante, que puede solicitar reunión de
                  aclaración si lo requiere o firmar y remitir el documento final. </p>
                  <p   >&nbsp;</p>
                  <p   >&nbsp;</p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b><span >INFORMACIÓN
                  SOLICITADA</span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p ><span
                  ><span >Explicación
                  de la información que se requiere</span></span></p>
                  <p ><span ><span >·<span >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span></span></span><span ><span >Con su lista de campos</span></span></p>
                  <p ><span ><span >·<span >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span></span></span><span ><span >Filtros necesarios (ejm: rangos de
                  fechas por un campo determinado, una entidad, etc)</span></span></p>
                  <p   >&nbsp;</p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b><span >OBSERVACIONES
                  CENDOJ</span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p ><span ><span >“Aprobado” u observaciones por parte
                  del CENDOJ</span></span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b><span >MEDIO
                  POR EL QUE SE ESPERA RECIBIR LA INFORMACIÓN</span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><span >&nbsp;</span></p>
                  <p   ><span
                  ><span >·<span
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span></span></span><span >Existen varias formas y
                  medios de obtener la información, dependiendo entre otros de:</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Tecnología existente en
                  la entidad solicitante</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Volúmen de datos a ser
                  obtenidos</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Periodicidad </span></p>
                  <p   ><span
                  ><span >·<span
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span></span></span><span >Entre los medios de
                  recibir la información están</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Aplicación Web</span></p>
                  <p   ><span ><span
                  >§<span >&nbsp;
                  </span></span></span><span >Con autenticación de
                  usuario y contraseña</span></p>
                  <p   ><span ><span
                  >§<span >&nbsp;
                  </span></span></span><span >Consulta directamente en
                  página web y/o descargar documento generado en el formato convenido.</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >EndPoint API REST</span></p>
                  <p   ><span ><span
                  >§<span >&nbsp;
                  </span></span></span><span >Con autenticación de
                  usuario y contraseña</span></p>
                  <p   ><span ><span
                  >§<span >&nbsp;
                  </span></span></span><span >Consulta de datos desde
                  otra aplicación</span></p>
                  <p   ><span ><span
                  >§<span >&nbsp;
                  </span></span></span><span >El endpoint responde
                  mediante la información en JSON, o en XML si se requiere</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Almacenamiento
                  compartido, donde se alojan los archivos en el formato convenido por un
                  tiempo determinado. Puede ser de la entidad solicitante o del CSJ,</span></p>
                  <p   ><span ><span
                  >§<span >&nbsp;
                  </span></span></span><span >Sitio FTP</span></p>
                  <p   ><span ><span
                  >§<span >&nbsp;
                  </span></span></span><span >Sitio HTTP</span></p>
                  <p   ><span ><span
                  >§<span >&nbsp;
                  </span></span></span><span >Carpeta compartida en red</span></p>
                  <p   ><span ><span
                  >§<span >&nbsp;
                  </span></span></span><span >Almacenamiento en Nube
                  (Azure, Google Cloud, AWS, etc)</span></p>
                  <p   ><span >o<span
                  >&nbsp;&nbsp; </span></span><span
                  >Otro, favor especificar.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b><span >OBSERVACIONES
                  CENDOJ</span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p ><span ><span >“Aprobado” u observaciones por parte
                  del CENDOJ</span></span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b><span >FORMATO
                  EN QUE SE ESPERA RECIBIR LA INFORMACIÓN</span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><span >&nbsp;</span></p>
                  <p   ><span
                  ><span >·<span
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span></span></span><span >El medio y el formato
                  están relacionados, entre los formatos comtemplados temenos:</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Documento JSON o XML
                  desde un Endpoint</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Texto plano en CSV</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Archivo de excel, XLSX</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Base de datos, como
                  backup comprimido de MSSQL 2017</span></p>
                  <p   ><span ><span
                  >o<span >&nbsp;&nbsp;
                  </span></span></span><span >Otro, favor especificar</span></p>
                  <p   >&nbsp;</p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b><span >OBSERVACIONES
                  CENDOJ</span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p ><span ><span >“Aprobado” u observaciones por parte
                  del CENDOJ</span></span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b><span >PERIODICIDAD
                  DE LA INFORMACIÓN</span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><span >Favor especificar la
                  periodicidad en la que se desea consultar la información, ejm: una única vez,
                  diaria, semanal, quincenal, mensual, trimestral, anual, etc.</span></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b><span >OBSERVACIONES
                  CENDOJ</span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p ><span ><span >“Aprobado” u observaciones por parte
                  del CENDOJ</span></span></p>
                  </td>
                </tr>
                <tr >
                  <td  ></td>
                  <td  ></td>
                  <td  ></td>
                  <td  ></td>
                  <td  ></td>
                  <td  ></td>
                </tr>
                </table>

                <p  >&nbsp;</p>

                <p >&nbsp;</p>

                <table     
                >
                <tr >
                  <td    >
                  <p   ><b>FIRMAS</b></p>
                  </td>
                </tr>
                <tr >
                  <td    >
                  <p   ><b>&nbsp;</b></p>
                  </td>
                  <td    >
                  <p   ><b>&nbsp;</b></p>
                  </td>
                </tr>
                <tr >
                  <td    >
                  <p   ><b>Firma funcionario solicitante </b></p>
                  </td>
                  <td    >
                  <p   ><b>Firma funcionario que aprueba</b></p>
                  </td>
                </tr>
                <tr >
                  <td  >
                  <p   ><b><span >Nombre
                  </span></b></p>
                  </td>
                  <td  >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                  <td  >
                  <p   ><b><span >Nombre
                  </span></b></p>
                  </td>
                  <td  >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                <tr >
                  <td  >
                  <p   ><b><span >Cargo
                  </span></b></p>
                  </td>
                  <td  >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                  <td  >
                  <p   ><b><span >Cargo</span></b></p>
                  </td>
                  <td  >
                  <p   ><span >Ingresar texto aquí.</span></p>
                  </td>
                </tr>
                </table>

                <p  ><b>&nbsp;</b></p>

                <p  >&nbsp;</p>

                <table     
                >
                <tr >
                  <td   >
                  <p   >&nbsp;</p>
                  </td>
                  <td   >
                  <p   >&nbsp;</p>
                  </td>
                  <td    >
                  <p   ><b><span >Control
                  de Versiones, Revisiones y Aprobaciones </span></b></p>
                  </td>
                  <td   >
                  <p   >&nbsp;</p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><b><span >Fecha </span></b><b><span >(aaaa-mm-dd)</span></b><b><span > </span></b></p>
                  </td>
                  <td   >
                  <p   ><b><span >Versión </span></b></p>
                  </td>
                  <td   >
                  <p   ><b><span >Descripción
                  </span></b></p>
                  </td>
                  <td   >
                  <p   ><b><span >Elaboró </span></b></p>
                  </td>
                  <td   >
                  <p   ><b><span >Revisó </span></b></p>
                  </td>
                  <td   >
                  <p   ><b><span >Aprobó </span></b></p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><span >2020-06-24 </span></p>
                  </td>
                  <td   >
                  <p   ><span >1.0 </span></p>
                  </td>
                  <td   >
                  <p   ><span >Documento
                  inicial </span></p>
                  </td>
                  <td   >
                  <p   ><span >Francisco
                  Rodríguez </span></p>
                  </td>
                  <td   >
                  <p   >&nbsp;</p>
                  </td>
                  <td   >
                  <p   >&nbsp;</p>
                  </td>
                </tr>
                <tr >
                  <td   >
                  <p   ><span >2020-07-01 </span></p>
                  </td>
                  <td   >
                  <p   ><span >1.1</span></p>
                  </td>
                  <td   >
                  <p   ><span >Agregada
                  Nota para la firma y secciones para Observaciones del CENDOJ</span></p>
                  </td>
                  <td   >
                  <p   ><span >Francisco
                  Rodríguez </span></p>
                  </td>
                  <td   >
                  <p   >&nbsp;</p>
                  </td>
                  <td   >
                  <p   >&nbsp;</p>
                  </td>
                </tr>
                </table>

                <p   ><b><span > </span></b></p>

                </div>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data(){
    return{
      tab: 'tab-parametros'
    }
  }
}
</script>  